import React, { useEffect, useState } from "react";
import "../styles/Home.css";
import { Container } from "react-bootstrap";
import { FiExternalLink } from "react-icons/fi";
import wfotimage from "../assets/images/wfot2.png";
import lady from "../assets/images/lady.jpg";
import man from "../assets/images/man.jpg";
// import man1 from "../assets/images/man1.jpg";
import man1 from "../assets/images/home_gallery_img.jpeg";
import meeting from "../assets/images/meeting.jpg";
import { useNavigate } from "react-router-dom";
import heroBg from "../assets/images/HeroBanner.png";
import { FileText, Users, ShieldCheck, Globe, ClipboardCheck, Bell } from "lucide-react";
import { IoLink, IoBulbOutline } from "react-icons/io5";
import { BsFillJournalBookmarkFill } from "react-icons/bs";
import { MdOutlineFeed } from "react-icons/md";
import { useLocation } from "react-router-dom";
import { restrictionConfig } from "../constants/restrictionConfig";
import RestrictionModal from "../components/RestrictionModal";


// Inside your component function:
const Home = () => {
  const [showAboutModal, setShowAboutModal] = useState(false);
  const navigate = useNavigate();
  const [tokenState, setTokenState] = useState(localStorage.getItem("token"));
  
  // API state
  const [latestUpdateData, setLatestUpdateData] = useState(null);
  const [allUpdates, setAllUpdates] = useState([]);
  const [currentUpdateIndex, setCurrentUpdateIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();
  const [showRestrictionModal, setShowRestrictionModal] = useState(false);

  useEffect(() => {
    if (location.state?.showRestriction) {
      setShowRestrictionModal(true);
      // Clear state after showing
      window.history.replaceState({}, document.title);
    }
  }, [location]);

  const storedUser = localStorage.getItem("user");
  const parsedUser = storedUser ? JSON.parse(storedUser) : null;
  const currentUserName = parsedUser?.name || "User";

  const handleAdminLogin = () => {
    navigate("/admin-login");
  };
  const handleMemberLogin = () => {
    navigate("/member-login");
  };
  const handleEdcclogin = () => {
    navigate("/edcc-login");
  };

  const handleViewMore = () => {
    setShowAboutModal(true);
  };

const iconItems = [
  { label: "OTICON 2027", link: "https://aiotabihar.com/", icon: IoLink },
  { label: "Licence Verification", link: "https://aiotadev.s3.ap-south-1.amazonaws.com/uploads/Guidelines%20%20IOTR%20April%202020.pdf", icon: IoBulbOutline },
  {
    label: "Professional status",
    link: "/license-professional-status",
    icon: ShieldCheck,
  },
  { label: "WFOT", link: "https://wfot.org", icon: Globe },
  { label: "Ergonomic Design Certification", link: "/Company-List", icon: BsFillJournalBookmarkFill },
  { label: "Circular", link: "https://aiota-live.s3.ap-south-1.amazonaws.com/updates/ERGONOMIC%20DESIGN%20CERTIFICATION%20COMMITTEE.pdf", icon: MdOutlineFeed },
];

  const handleClick = (link) => {
    if (link.startsWith("http") || link.startsWith("https")) {
      window.open(link, "_blank", "noopener,noreferrer"); // external
    } else {
      navigate(link); // internal
    }
  };

  // Fetch latest update summary
  const fetchLatestUpdateSummary = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASEURL}/latest-update`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();
      if (result.success && result.data) {
        setLatestUpdateData(result.data);
      }
    } catch (err) {
      console.error('Error fetching latest update summary:', err);
      setError('Failed to load latest update');
    }
  };

  // Fetch all updates for navigation
  const fetchAllUpdates = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASEURL}/getAllUpdates`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();
      if (result.success && result.data) {
        // Filter only active updates
        const activeUpdates = result.data.filter(update => update.status === 1);
        setAllUpdates(activeUpdates);
      }
    } catch (err) {
      console.error('Error fetching all updates:', err);
    } finally {
      setLoading(false);
    }
  };

  // Format date function
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const options = { day: 'numeric', month: 'long', year: 'numeric' };
    return date.toLocaleDateString('en-GB', options);
  };

  // Navigation functions
  const handlePreviousUpdate = () => {
    if (allUpdates.length > 0) {
      setCurrentUpdateIndex((prev) => 
        prev === 0 ? allUpdates.length - 1 : prev - 1
      );
    }
  };

  const handleNextUpdate = () => {
    if (allUpdates.length > 0) {
      setCurrentUpdateIndex((prev) => 
        prev === allUpdates.length - 1 ? 0 : prev + 1
      );
    }
  };

  // Get current update for display
  const getCurrentUpdate = () => {
    if (allUpdates.length === 0) return null;
    return allUpdates[currentUpdateIndex];
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const currentToken = localStorage.getItem("token");
      if (currentToken !== tokenState){
        setTokenState(currentToken);
      }
    }, 500);
    return () => clearInterval(interval);
  }, [tokenState]);

  // Fetch data on component mount
  useEffect(() => {
    fetchLatestUpdateSummary();
    fetchAllUpdates();
  }, []);

  const currentDisplayUpdate = getCurrentUpdate();

  return (
    <div className="home" >
      {/* Fixed Hero Section */}
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})`}}>
        <div className="latest-updates-banner">
          <Container fluid >
            <marquee behavior="scroll" direction="left" loop="infinite" className="latest-updates-wrap d-flex align-items-center">
                <p
                  className="update-latests poppins-medium"
                  style={{ marginBottom: "0rem" }}>
                  {loading ? 
                    "Loading latest update..." :    
                    error ? 
                    "LATEST UPDATE: OCCUPATIONAL THERAPY SKILL BUILDING WEBINAR SERIES No: 3" :
                    latestUpdateData?.latestUpdate ? 
                    `LATEST UPDATE: ${latestUpdateData.latestUpdate.title.toUpperCase()}` :
                    "No latest updates available"
                  }
                </p>
            </marquee>
          </Container> 
        </div>

        <div className="hero-scroll-content">
          {/* <div className={tokenState ? "hero-content-home poppins-regular" : "hero-content poppins-regular"}> */}
          <div className="hero-content-home poppins-regular"  style={{marginTop:`60px` }}>
            <h1 className="hero-heading">All India Occupational Therapists' Association</h1>
              {!tokenState && (
                <div className="hero-buttons">
                    {/* <button className="glass-button" onClick={handleAdminLogin}>
                      Admin Login
                    </button> */}
                <button className="glass-button" onClick={handleMemberLogin}>
                  Member Login
                </button>
                <button className="glass-button" onClick={handleEdcclogin}>
                  Ergonomic Certificate login
                </button>
              </div>
              )}
          </div>
        </div>
      </section>

      {/* Scrollable Content Container */}
      {/* <div className={tokenState ? "scrollable-content-home" : "scrollable-content"}> */}
      <div className="scrollable-content-home">
        <div className="content-container">
          {/* Updates and Guidelines Section */}
          <section className="info-cards">
            <div className="container">
              <div className="row align-items-center">
                {/* Left Column - Divided into two rows */}
                <div className="col-md-6">
                  {/* First Row - Latest Updates */}
                  <div className="mb-4">
                    <div className="card latest-updates">
                      <div className="updates-header">
                        <h2 className="updates-title">
                          Latest Updates ({loading ? "..." : latestUpdateData?.totalUpdates || 0})
                        </h2>
                        <div className="arrow-buttons">
                          <button 
                            className={`arrow-btn ${allUpdates.length <= 1 ? 'hidden' : ''}`}
                            onClick={handlePreviousUpdate}
                            disabled={loading || allUpdates.length <= 1}
                          >
                            &lt;
                          </button>
                          <button 
                            className={`arrow-btn ${allUpdates.length <= 1 ? 'hidden' : ''}`}
                            onClick={handleNextUpdate}
                            disabled={loading || allUpdates.length <= 1}
                          >
                            &gt;
                          </button>
                        </div>
                      </div>
                      <div className="update-content">
                        <p
  className="start"
  style={{ fontStyle: 'italic' }}
>
  {loading ? 
    "Loading update..." :
    error ?
    "Starting from December 1, 2024, All payments made to AIOTA will include an additional 18% GST." :
    currentDisplayUpdate ? 
    currentDisplayUpdate.description :
    latestUpdateData?.latestUpdate?.description ||
    "No updates available"
  }
</p>
                        <span className="date">
                          {loading ? 
                            "..." :
                            error ?
                            "20 October 2025" :
                            currentDisplayUpdate ? 
                            formatDate(currentDisplayUpdate.createdAt) :
                            latestUpdateData?.latestUpdateDate ? 
                            formatDate(latestUpdateData.latestUpdateDate) :
                            "No date available"
                          }
                        </span>
                      </div>
                      <div className="btn-container">
                        <button className="btn-view-all" onClick={() => navigate('/latest-updates')}>VIEW ALL</button>
                      </div>
                    </div>
                  </div>

                  {/* Second Row - Membership Guidelines */}
                  <div>
  <div 
    className="card membership-guidelines"
    onClick={() => navigate('/photo-gallery')}
    style={{ cursor: 'pointer' }}
    role="button" 
    tabIndex={0} 
    onKeyDown={(e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        navigate('/photo-gallery');
      }
    }}
  >
    <a
      className="image-link-icon"
      title="Open"
      style={{ pointerEvents: 'auto' }}
    >
      <span className="material-symbols-outlined">arrow_outward</span>
    </a>
    <div className="card-header">
      <h2>Explore AIOTA Moments</h2>
    </div>
    <div className="card-body">
      <p>
        Discover Photographs from AIOTA's national conferences, educational programs, awareness campaigns, and community initiatives.
      </p>
    </div>
  </div>
</div>
                </div>

                {/* Right Column - Image */}
              <div className="col-md-6">
  <div 
    className="about-image-container"
    onClick={() => window.open('https://wfot.org/', '_blank')} // Opens in new tab; use navigate('/wfot') for internal routing if needed
    style={{ cursor: 'pointer' }} // Visual indicator for clickability
    role="button" 
    tabIndex={0} 
    onKeyDown={(e) => { // Optional: keyboard accessibility
      if (e.key === 'Enter' || e.key === ' ') {
        window.open('https://wfot.org/', '_blank');
      }
    }}
  >
    <img
      src={wfotimage}
      alt="World Federation of Occupational Therapists"
      className="img-fluid"
    />
    <div className="permanent-overlay"></div>
    <div className="image-text">
      <span>World Federation of Occupational Therapists</span>
    </div>
    <a
      className="image-link-icon"
      title="Open"
      style={{ pointerEvents: 'auto' }} // Ensure the arrow link remains clickable independently
    >
      <span className="material-symbols-outlined">arrow_outward</span>
    </a>
  </div>
</div>
              </div>
            </div>
          </section>

          {/* About Section */}
          <section className="about">
            <div className="container">
              <div className="row" style={{ minHeight: "600px" }}>
                <div className="col-xl-5 col-lg-12">
                  <div className="content-side">
                    <h2>All India Occupational Therapists</h2>
                    <p>
                      All India Occupational Therapists' Association (AIOTA) was
                      founded by an American lady Mrs. Kamala V. Nimbkar née
                      Elizabeth Lundy in the year 1952. She was its Founder
                      President and held this office till 1959.
                    </p>
                    <button className="view-more-btn" onClick={handleViewMore}>
                      VIEW MORE
                    </button>
                  </div>
                </div>
                <div className="col-xl-7 col-lg-12">
                  <div className="images-side">
                    <div className="row mb-2">
                      {/* Top Left - Larger width */}
                      <div className="col-8 tlimage">
                        <div className="image-item" style={{height: '280px',width:'75% '}}>
                          <img src={man1} alt="Modern OT Workspace" />
                        </div>
                      </div>
                      {/* Top Right - Taller */}
                      <div className="col-4">
                        <div className="image-item" style={{height: '340px'}}>
                          <img src={man} alt="Historical AIOTA member" />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      {/* Bottom Left - Square */}
                      <div className="col-4">
                        <div className="image-item" style={{height: '200px'}}>
                          <img src={lady} alt="Therapy Session" />
                        </div>
                      </div>
                      {/* Bottom Right - Wide, shorter */}
                      <div className="col-8">
                        <div className="image-item" style={{height: '260px',width:'75%'}}>
                          <img src={meeting} alt="Helping Hand" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Vision & Mission Section */}
          <section className="vision-mission">
            <div className="container">
              <div className="content-wrapper">
                <div className="text-content">
                  <h2>Our Vision & Mission</h2>
                  <p>
                    The All India Occupational Therapists' Association (AIOTA)
                    was founded in 1952 by Mrs. Kamala V. Nimbkar (née Elizabeth
                    Lundy), an American, who served as its first President until
                    1959. AIOTA was also a founding council member of the World
                    Federation of Occupational Therapists (WFOT), established
                    the same year. It was officially registered under the Bombay
                    Public Trust Act on 29th June 1955 (Registration No. E-1118,
                    Bom.).
                  </p>
                  {/* <div className="progress-dots">
                    <div className="dot active"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                  </div> */}
                </div>
<div className="icons-grid">
  {iconItems.map((item, idx) => (
    <div
      key={idx}
      className="icon-item"
      onClick={() => handleClick(item.link)}
      style={{ cursor: "pointer" }}
    >
      <div className="icon">
        <item.icon size={46} color="white" /> 
      </div>
      <p>{item.label}</p>
    </div>
  ))}
</div>

              </div>
            </div>
          </section>

          {/* Gallery Section */}
          <section className="gallery">
            <div className="home-overlay"></div>
            <div className="container">
              <div className="gallery-grid">
                {/* Add gallery images or content here */}
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* About Modal - Slides from left */}
      {/* About Modal - Slides from left */}
      {showAboutModal && (
        <div className="modal-overlay-home" onClick={() => setShowAboutModal(false)}>
          <div className="modal-content-home" onClick={(e) => e.stopPropagation()}>
            <button
              className="modal-close"
              onClick={() => setShowAboutModal(false)}>
              ×
            </button>
            <div className="modal-header">
              <h1>All India Occupational Therapists</h1>
            </div>
            <div className="modal-body">
              <div className="modal-text-content">
                <p>
                  All India Occupational Therapists' Association (AIOTA) was
                  founded by an American lady Mrs. Kamala V. Nimbkar née
                  Elizabeth Lundy in the year 1952. She was its Founder
                  President and held this office till 1959. AIOTA was also one
                  of the Founder Council Members of the World Federation of
                  Occupational Therapists (WFOT) which too came to existence in
                  1952. She got All India Occupational Therapists' Association
                  registered under Bombay Public Trust Act, Bombay on 29th June
                  1955, vide Registration No. E-118 (Bom.).
                </p>
                <p>
                  Under her guidance on November 14th 1950 the Occupational
                  Therapy Center with First OT School in India and Asia
                  Importing Diploma Program was inaugurated by Union Health
                  Minister Rajkumari Amrit Kaur, at K.E.M. hospital, Mumbai with
                  Mrs. Nimbkar as its Hon. Director. This program was accredited
                  by AIOTA in 1952 and was approved by WFOT in the year 1954.
                  Many students from Sri Lanka, Malaya, Indonesia and other
                  south east countries were trained at this center under her
                  guidance and spread the word of Occupational Therapy in Asian
                  region. Mrs. Nimbkar also attended First WFOT Council Meeting
                  at Edinburgh as WFOT Delegate from India in the year 1954.
                </p>
                <p>
                  After retiring from the Occupational Therapy School, Bombay in
                  1957, at the behest of Government of Maharashtra Mrs. Nimbkar
                  also established second School of OT at the Govt. Medical
                  College & Hospital, Nagpur in 1958.
                </p>
                <p>
                  AIOTA is regularly organizing annual national conferences to
                  update members on recent advances and research in the areas of
                  vivid interest. The first such national conference was
                  organized by Mrs. Nimbkar in 1953 at Mumbai.
                </p>
                <p>
                  She also brought out The Indian Journal of Occupational
                  Therapy, as an official publication of AIOTA and its first
                  issue was published in 1956. The IJOT now developed as a peer
                  reviewed Journal indexed in many of the national &
                  international databases is mandated to publish original
                  scientific research papers, case reports and preliminary
                  articles on all aspects of Occupational Therapy. It was
                  registered in 1957 with Office of the Registrar of News Papers
                  of India vide Registration No. 1653/57 with Mrs. Nimbkar as
                  its first Editor.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      <RestrictionModal
        show={showRestrictionModal}
        onHide={() => setShowRestrictionModal(false)}
        title={restrictionConfig.popupTitle}
        message={restrictionConfig.popupMessage}
        buttonText={restrictionConfig.buttonText}
        userName={currentUserName}
      />
    </div>
  );
};

export default Home;